import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

const prefix = '/admin/gamification'

// ─── Mission Categories ─────────────────────────────────────
export const missionCategoryList = (params = '') => Http.get(`${prefix}/mission-categories${serialize(params)}`)
export const missionCategoryByID = (id) => Http.get(`${prefix}/mission-categories/${id}`)
export const missionCategoryCreate = (params) => Http.post(`${prefix}/mission-categories`, params)
export const missionCategoryUpdate = (params) => Http.put(`${prefix}/mission-categories/${params.id}`, params)
export const missionCategoryDestroy = (params) => Http.delete(`${prefix}/mission-categories/${params.id}`)

// ─── Missions ───────────────────────────────────────────────
export const missionList = (params = '') => Http.get(`${prefix}/missions${serialize(params)}`)
export const missionByID = (id) => Http.get(`${prefix}/missions/${id}`)
export const missionCreate = (params) => Http.post(`${prefix}/missions`, params)
export const missionUpdate = (params) => Http.put(`${prefix}/missions/${params.id}`, params)
export const missionDestroy = (params) => Http.delete(`${prefix}/missions/${params.id}`)
export const missionToggle = (id) => Http.post(`${prefix}/missions/${id}/toggle`)

// ─── Achievement Categories ─────────────────────────────────
export const achievementCategoryList = (params = '') => Http.get(`${prefix}/achievement-categories${serialize(params)}`)
export const achievementCategoryByID = (id) => Http.get(`${prefix}/achievement-categories/${id}`)
export const achievementCategoryCreate = (params) => Http.post(`${prefix}/achievement-categories`, params)
export const achievementCategoryUpdate = (params) => Http.put(`${prefix}/achievement-categories/${params.id}`, params)
export const achievementCategoryDestroy = (params) => Http.delete(`${prefix}/achievement-categories/${params.id}`)

// ─── Achievements ───────────────────────────────────────────
export const achievementList = (params = '') => Http.get(`${prefix}/achievements${serialize(params)}`)
export const achievementByID = (id) => Http.get(`${prefix}/achievements/${id}`)
export const achievementCreate = (params) => Http.post(`${prefix}/achievements`, params)
export const achievementUpdate = (params) => Http.put(`${prefix}/achievements/${params.id}`, params)
export const achievementDestroy = (params) => Http.delete(`${prefix}/achievements/${params.id}`)

// ─── Level Definitions ──────────────────────────────────────
export const levelDefinitionList = () => Http.get(`${prefix}/level-definitions`)
export const levelDefinitionUpdate = (params) => Http.put(`${prefix}/level-definitions/${params.id}`, params)

// ─── Reward Rules ───────────────────────────────────────────
export const rewardRuleList = (params = '') => Http.get(`${prefix}/reward-rules${serialize(params)}`)
export const rewardRuleCreate = (params) => Http.post(`${prefix}/reward-rules`, params)
export const rewardRuleUpdate = (params) => Http.put(`${prefix}/reward-rules/${params.id}`, params)
export const rewardRuleDestroy = (params) => Http.delete(`${prefix}/reward-rules/${params.id}`)

// ─── Reward Items ───────────────────────────────────────────
export const rewardItemList = (params) => Http.get(`${prefix}/reward-items${serialize(params)}`)
export const rewardItemByID = (id) => Http.get(`${prefix}/reward-items/${id}`)
export const rewardItemCreate = (params) => Http.post(`${prefix}/reward-items`, params)
export const rewardItemUpdate = (params) => Http.put(`${prefix}/reward-items/${params.id}`, params)
export const rewardItemDestroy = (params) => Http.delete(`${prefix}/reward-items/${params.id}`)

// ─── Redemptions ────────────────────────────────────────────
export const redemptionList = (params) => Http.get(`${prefix}/redemptions${serialize(params)}`)
